// extracted by mini-css-extract-plugin
module.exports = {"illustration":"fallback-Screen-illustration-ac34f5af","wrapper":"fallback-Screen-wrapper-a2701d52"};